// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

import { Drawer } from '@mantine/core';
import type { Patient } from '@medplum/fhirtypes';
import type { JSX } from 'react';
import { PatientListSidebar } from '../../pages/patient/list/PatientListSidebar';

interface SelectPatientDrawerProps {
  opened: boolean;
  onClose: () => void;
  onPatientSelect: (patient: Patient) => void;
}

export function SelectPatientDrawer({ opened, onClose, onPatientSelect }: SelectPatientDrawerProps): JSX.Element {
  return (
    <Drawer
      opened={opened}
      onClose={onClose}
      title="Select a patient"
      position="right"
      size="md"
      styles={{
        content: { display: 'flex', flexDirection: 'column' },
        body: { flex: 1, minHeight: 0, padding: 0, display: 'flex', flexDirection: 'column' },
      }}
    >
      <PatientListSidebar onPatientSelect={onPatientSelect} />
    </Drawer>
  );
}
